import * as React from "react";
import { useDispatch, useSelector } from 'react-redux';
import { Dialog } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Button } from "@progress/kendo-react-buttons";
import { AutoComplete } from "@progress/kendo-react-dropdowns";
import { Checkbox, Input, Switch } from "@progress/kendo-react-inputs";
import { Error } from "@progress/kendo-react-labels";
import { getter } from "@progress/kendo-react-common";
import { passwordValidation } from "../utils/passwordValidation";
import { deleteField } from "../actions";

const FormInput = (fieldRenderProps) => {
  const { validationMessage, visited, ...others } = fieldRenderProps;
  return (
    <div>
      <Input {...others} />
      {
        visited && validationMessage && <Error direction={"end"} style={{ flexDirection: 'column' }}>{validationMessage}</Error>
      }
    </div>
  );
};


const EditPrndForm = (props) => {
  const { token } = useSelector(state => state.authReducer);

  const submit = (event, props) => {
    props.onSubmit({ ...event }, event.Groups);
  }

  const FormAutoComplete = (fieldRenderProps) => {
    const { validationMessage, visited, ...others } = fieldRenderProps;
    if (fieldRenderProps.value && fieldRenderProps.value != props.addressVal) {
      //props.addressHandler(fieldRenderProps.value);

    }
    return (
      <div>
        <AutoComplete onChange={() => console.log('')} data={props.addressDataSource} textField={'text'} {...others} />
        {
          visited && validationMessage && <Error direction={"end"} style={{ flexDirection: 'column' }}>{validationMessage}</Error>
        }
      </div>
    );
  }

  return <Dialog
    title={props.item.id ? 'Edit PRND Record' : 'Create PRND Record'}
    style={{ zIndex: 2 }}
    onClose={props.cancelEdit}
  >
    <Form
      style={{ maxHeight: '600px', minWidth: '500px' }}
      onSubmit={(e) => submit(e, props)}
      initialValues={props.item}
      ignoreModified={true}
      render={(formRenderProps) => (
        <FormElement style={styles.formElement}>
          <fieldset className={"k-form-fieldset"}>
            <div style={{ height: '460px', paddingRight: '10px', overflowY: 'scroll' }}>
              <div style={styles.accountDiv}>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"region"} component={FormInput} label={"Region"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"address"} component={AutoComplete} data={props.addressDataSource} textField={'text'} onChange={props.addressHandler} label={"Address"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"capabilities"} component={FormInput} label={"Capabilities"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"quantity"} component={FormInput} label={"Quantity"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"city"} component={FormInput} label={"City"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"county"} component={FormInput} label={"County"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"location"} component={FormInput} label={"Location"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"manufacturer"} component={FormInput} label={"Manufacturer"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"mission"} component={FormInput} label={"Mission"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"model"} component={FormInput} label={"Model"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"poc1Name"} component={FormInput} label={"Primary POC Name"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"poc1Phone"} component={FormInput} label={"Primary POC Phone"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"poc2Name"} component={FormInput} label={"Secondary POC Name"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"poc2Phone"} component={FormInput} label={"Secondary POC Phone"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"serialNo"} component={FormInput} label={"Serial Number"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"state"} component={FormInput} label={"State"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"lat"} component={FormInput} label={"Latitude"} />
                </div>
                <div className="mb-3" style={styles.formField}>
                  <Field name={"long"} component={FormInput} label={"Longitude"} />
                </div>
              </div>
            </div>
          </fieldset>
          <div className="k-form-buttons k-justify-content-end" style={{ paddingBottom: '10px' }}>
            <button type={"submit"} className="k-button k-primary" style={styles.modalBtn} disabled={false}>
              Save
            </button>
            <button type={"submit"} className="k-button" style={styles.modalBtn} onClick={props.cancelEdit}>
              Cancel
            </button>
          </div>
        </FormElement>
      )}
    />
  </Dialog>
}

const styles = {
  formElement: {
    width: 465,
    maxHeight: 525,
    minHeight: 525
  },
  formField: {
    marginTop: 10,
    marginBottom: 25,
  },
  formLabel: {
    fontWeight: 'bold',
    fontSize: 18,
  },
  adminSection: {
    marginTop: 20,
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'row'
  },
  modalBtn: {
    padding: '10px 15px'
  },
  accountDiv: {
    backgroundColor: '#F5F5F5',
    padding: '8px',
    border: '2px solid #DCDCDC',
    borderRadius: '6px'
  }
  //    padding: 8px 24px;
}

export default EditPrndForm;